import { action, makeObservable, observable } from 'mobx';
import { useEffect } from 'react';
import { API } from '~/api';
import { ApiService } from '~/service/service.api';
import { UIService } from '~/service/service.ui';
import { BrandId } from '~/shared/dto/id';
import { Model } from '~/shared/service/service.base';
import { Async } from '~/shared/tools/async';
import { FeedbackDrawerModel } from './model.feedback.drawer';

@Model()
export class BrandSuggestionsModel {
	private brandId?: BrandId;

	@observable data = [] as API.Feedback[];
	@observable total = 0;
	@observable offset = 0;

	readonly limit = 20;
	readonly async = new Async();
	readonly drawer;

	constructor(
		private api: ApiService,
		private ui: UIService,
	) {
		makeObservable(this);
		this.drawer = new FeedbackDrawerModel(this.api, this.ui, this.reload);
	}

	use = (brandId: BrandId) => {
		this.brandId = brandId;
		useEffect(() => this.reload(), []);
	};

	fetchNextPage = () => {
		const { brandId, limit, offset, total, async } = this;
		if (!brandId || async.loading) return;
		if (!total || offset >= total) return;

		this.async.call(async () => {
			const { data } = await this.api.feedbackGetBrandSuggestions(brandId, { limit, offset });
			return () => {
				this.data = [...this.data, ...data.items];
				this.offset += this.limit;
			};
		});
	};

	@action.bound reload() {
		this.offset = 0;
		const { brandId, limit, offset } = this;
		if (!brandId) return;
		this.async.call(async () => {
			const { data } = await this.api.feedbackGetBrandSuggestions(brandId, { limit, offset });
			return () => {
				this.data = data.items;
				this.total = data.total;
				this.offset = this.limit;
			};
		});
	}
}
